/** Move `id` to `oneBased` rank (1 = top) in the ballot order (Breakout D — keyboard rank shortcut). */
export function moveIdToOneBasedRank(order: number[], id: number, oneBased: number): number[] {
	if (oneBased < 1 || oneBased > order.length) return order;
	const idx = order.indexOf(id);
	if (idx < 0) return order;
	const targetIdx = oneBased - 1;
	if (idx === targetIdx) return order;
	const next = order.filter((x) => x !== id);
	next.splice(targetIdx, 0, id);
	return next;
}
